// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBqCy4QhUrKQZVQaUvJtlkEBbTH2q6KEXw",
  authDomain: "karthik-os.firebaseapp.com",
  projectId: "karthik-os",
  storageBucket: "karthik-os.firebasestorage.app",
  messagingSenderId: "102728003530",
  appId: "1:102728003530:web:52337965e14c3199716933",
  measurementId: "G-ZDYSPF2CEV"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
